import * as Yup from 'yup';
import { SarlaftSurvey } from '../../../../../../shared/types/modules/sarlaft';

export const initialValues: SarlaftSurvey = {
    wieldsPoliticalPower: false,
    generalPublicRecognition: false,
    taxesOtherCountries: false,
    publiclyExposedPerson: false,
    managesPublicResources: false,
    which: '',
};

export const validationSchema = Yup.object({
    wieldsPoliticalPower: Yup.boolean(),
    generalPublicRecognition: Yup.boolean(),
    taxesOtherCountries: Yup.boolean(),
    publiclyExposedPerson: Yup.boolean(),
    which: Yup.string().when('publiclyExposedPerson', {
        is: true,
        then: () =>
            Yup.string().required(
                'Este campo es obligatorio cuando la persona es públicamente expuesta'
            ),
    }),
    managesPublicResources: Yup.boolean(),
});
